import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { WhistleblowingProgramPageContent } from "./WhistleBlowingProgramPageContent";
import { WhistleBlowingProgramPageHeading } from "./WhistleBlowingProgramPageHeading";
import { WhistleblowingProgramNextPage } from "./WhistleBlowingProgramNextPage";

export const WhistleBlowingProgram = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "whistleblowingProgramPageHeading",
      children: <WhistleBlowingProgramPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "whistleblowingProgramPageContent",
      children: <WhistleblowingProgramPageContent/>
    },
    {
      label: "Next Page",
      key: "whistleblowingProgramNextPage",
      children: <WhistleblowingProgramNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
